import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { getUrls } from '../../../../../utils/url';

const StyledLabelFieldDiv = styled.div`
    display: flex;
    flex-direction: column;
`;
const UrlDiv = styled.div`
    margin-top: 24px;
    display: flex;
    align-items: center;
`;

const URLValue: React.FC = () => {
    const { t } = useTranslation('admin_settings');
    const { api } = getUrls();
    const url = `${api}/lti/course`;
    return (
        <UrlDiv>
            <StyledLabelFieldDiv>
                <Typography>{t('url')}</Typography>
                <a href={url}>{url}</a>
            </StyledLabelFieldDiv>
        </UrlDiv>
    );
};

export default URLValue;
